import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <a
          className="App-link"
          href="https://pages.cloudflare.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Built on Pages
        </a>
      </header>
    </div>
  );
}

export default App;
